import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/form/states/data/`

export default {
  getFormStates(formId) {
    return ApiService.get(`${resourceUrl}${formId}`)
  },
  saveFormStates(data) {
    return ApiService.post(`${resourceUrl}save`, data)
  },
  saveParentFormData(data) {
    return ApiService.post(`${resourceUrl}saveFromParent`, data)
  },
  isStateUsedInRecords(data) {
    return ApiService.post(`${resourceUrl}isStateUsedInRecords`, data)
  },
}
